import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ isImpartner?: boolean }>()(
  (theme, { isImpartner }) => ({
    footerWrapper: {
      marginLeft: isImpartner ? theme.spacing(-39.75) : theme.spacing(5),
    },
    footerWrapperIframe: {
      padding: theme.spacing(0, 4),
    },
    root: {
      height: theme.spacing(8),
      padding: theme.spacing(1.5, 5),
    },
    buttonWrapper: {
      display: 'flex',
      gap: theme.spacing(3),
      flexDirection: 'row',
      alignItems: 'center',
    },
    autosave: {
      top: ' 50%',
    },
    innerfooterWrapper: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    innerfooterWrapperLeft: {
      justifyContent: 'flex-end',
    },
    productCount: {
      fontFamily: `${theme.typography.fontFamily} !important`,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: ' 20px',
      letterSpacing: '0.25px',
      color: theme.palette.labraText.tertiary,
    },
    disableBtn: {
      cursor: 'not-allowed',
    },
    modalText: {
      fontSize: '14px !important',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px !important',
      letterSpacing: '0.25px',
      color: theme.palette.labraText.description,
      fontFamily: theme.typography.fontFamily,
      textAlign: 'left',
      width: theme.spacing(52.5),
    },
    nameBoldText: {
      fontSize: '14px !important',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '20px !important',
      letterSpacing: '0.1px',
      color: theme.palette.labraText.description,
      fontFamily: theme.typography.fontFamily,
      textAlign: 'left',
    },
    footerRight: {
      justifyContent: 'flex-end',
    },
    clearModalText: {
      fontSize: '14px !important',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px !important',
      letterSpacing: '0.25px',
      color: theme.palette.labraText.description,
      fontFamily: theme.typography.fontFamily,
      textAlign: 'left',
      width: theme.spacing(52.5),
      display: 'flex',
      flexDirection: 'column',
    },
  })
)
